
import {initWebComponent} from "@/helpers/web-component-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";

export class LayerInfoToolsButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-button data-icon="fa fa-pencil-ruler" data-title="tools"></layer-info-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            showLayerInfoButton('layer-info-tools')
        })
    }
}

